"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotExistError = void 0;
exports.NotExistError = new Error('Entity not exist');
//# sourceMappingURL=errors.js.map